var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlmiyaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.542 2.1774H6.50138C3.58578 2.1774 1.22119 4.54199 1.22119 7.45759V36.4982C1.22119 39.4146 3.58578 41.7792 6.50219 41.7792H35.542C38.4584 41.7792 40.823 39.4146 40.823 36.4982V7.45759C40.823 4.54118 38.4592 2.1774 35.5428 2.1774H35.542Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5414 43H6.50161C2.91641 43 0 40.0836 0 36.4984V7.45775C0 3.87335 2.91641 0.95694 6.50081 0.95694H35.5414C39.1258 0.95694 42.0423 3.87335 42.0423 7.45775V36.4984C42.0423 40.0836 39.1258 43 35.5406 43H35.5414ZM6.50081 3.39817C4.26207 3.39817 2.44123 5.21901 2.44123 7.45775V36.4984C2.44123 38.7371 4.26288 40.558 6.50081 40.558H35.5406C37.7794 40.558 39.6002 38.7363 39.6002 36.4984V7.45775C39.6002 5.21901 37.7794 3.39817 35.5406 3.39817H6.50081Z",
    fill: "#67B3FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_14137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.542 2.1774H6.50138C3.58578 2.1774 1.22119 4.54199 1.22119 7.45759V36.4982C1.22119 39.4146 3.58578 41.7792 6.50219 41.7792H35.542C38.4584 41.7792 40.823 39.4146 40.823 36.4982V7.45759C40.823 4.54118 38.4592 2.1774 35.5428 2.1774H35.542Z",
    fill: "#3B82F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_14137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9116 10.3227C18.9116 10.0226 18.9649 9.7483 19.0722 9.49821C19.1795 9.24892 19.3295 9.02707 19.5223 8.83425C19.7151 8.64144 19.9362 8.49138 20.1863 8.38408C20.4356 8.27679 20.7034 8.22354 20.9898 8.22354C21.5892 8.22354 22.0959 8.42362 22.5105 8.82296C22.9244 9.22311 23.1317 9.72249 23.1317 10.3219C23.1317 10.6075 23.0745 10.8753 22.9607 11.1254C22.8461 11.3755 22.6929 11.5966 22.5001 11.7894C22.3072 11.9822 22.0822 12.1355 21.8256 12.25C21.5683 12.3646 21.2899 12.4211 20.9906 12.4211C20.6913 12.4211 20.4372 12.3638 20.1871 12.25C19.937 12.1355 19.716 11.9822 19.5231 11.7894C19.3303 11.5966 19.1803 11.3755 19.073 11.1254C18.9657 10.8761 18.9124 10.6083 18.9124 10.3219L18.9116 10.3227ZM22.8526 32.9844C22.8526 33.2417 22.8058 33.4805 22.713 33.7016C22.6203 33.9234 22.4912 34.1162 22.3274 34.28C22.1636 34.4438 21.97 34.5769 21.749 34.6761C21.5271 34.7762 21.2883 34.8262 21.0318 34.8262C20.7752 34.8262 20.5356 34.7762 20.3146 34.6761C20.0927 34.5761 19.8967 34.4438 19.7256 34.28C19.5546 34.1162 19.4183 33.9234 19.319 33.7016C19.219 33.4805 19.169 33.2409 19.169 32.9844V16.7703C19.169 16.2564 19.3513 15.8175 19.7151 15.4528C20.079 15.0882 20.5251 14.9067 21.0535 14.9067C21.582 14.9067 21.9958 15.089 22.3387 15.4528C22.6816 15.8167 22.8526 16.2564 22.8526 16.7703V32.9844Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_14137",
    x: 1.22119,
    y: 2.1774,
    width: 39.6021,
    height: 39.6018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.83522
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_14137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_14137",
    x: 17.334,
    y: 7.73052,
    width: 6.5867,
    height: 28.9691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.394414,
    dy: 0.690224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.59162
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_14137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_14137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlmiyaIcon);
export default __webpack_public_path__ + "static/media/ilmiya-icon.e05a1aa38d2ab7c7ae8da0df400e3298.svg";
export { ForwardRef as ReactComponent };